import { cancelSubscription, createNewOrder, getOrderStatus, setDefaultPaymentMethod } from './api';

export { pollGetOrderStatus } from './api';

export const ordersApi = {
  cancelSubscription,
  createNewOrder,
  getOrderStatus,
  setDefaultPaymentMethod,
};
